import CKLogo from '../../assets/credit-karma/image/credit-karma.svg';
import InverseToggleLogo from '../../assets/toggle/image/TAFC-inverse.svg';
import LightToggleLogo from '../../assets/toggle/image/TAFC-ongreen_1.svg';
import KnockoutCopy from '../../components/KnockoutCopy/KnockoutCopy';
import { prepUrlForEnvironment } from '../../utils';

const mfaSuccessHost = prepUrlForEnvironment({
  url: process.env.REACT_APP_MFA_SUCCESS_REDIRECT_HOST,
});

const config = {
  coverageStartDateConfig: {
    infoCopy: null,
    labelCopy: 'Select a start date',
  },
  discountsConfig: {
    hasCarbonOffsetDiscount: true,
    hasPartnerDiscount: true,
  },
  featureFlags: {
    isAccountManagementEnabled: false,
    isAutoPurchaseFlowEnabled: true,
    isAutoQuoteLinkExchangeEnabled: true,
    isDirectToAutoQuoteEnabled: false,
    isLogoRedirectInAutoPurchaseFlowEnabled: false,
    isPrivacyAndTermsEnabled: false,
    isRentersQuoteCreationEnabled: false,
    isSelfServiceEnabled: false,
  },
  footerConfig: {
    hasNavItems: false,
    hasSocialLinks: false,
    tenantPhoneVariant: 'second-row',
  },
  iidKnockoutCopy: {
    featureFlag: 'isUpdatedCreditKarmaKnockoutCopy',
    subHeader: <KnockoutCopy phoneNumber="855-449-2814" />,
  },
  localforageDbName: 'credit_karma',
  logos: {
    default: CKLogo,
    light: CKLogo,
    title: 'Toggle + Credit Karma logo',
    toggleDefault: InverseToggleLogo,
    toggleLight: LightToggleLogo,
  },
  navBarConfig: {
    hasNavBarItems: false,
  },
  notifyConfig: {
    discountCopy:
      'Congratulations! Being a Credit Karma member unlocks a discount and exclusive features.',
  },
  primaryVehicleDataSource: undefined,
  purchaseFlowConfig: {
    checkoutToggleCustomerDefault: undefined,
  },
  quoteExpirationCondition: {
    maxElapsedTimeMinutes: 60,
    onConfirmDestination: 'https://www.creditkarma.com/',
    timestampKey: 'created_at',
  },
  redirectUrls: {
    indexRedirectUrl: 'https://www.creditkarma.com/',
    logoRedirectUrl: null,
    mfaSuccessRedirectUrl: `${mfaSuccessHost}my-account`,
    navBlockerRedirectUrl: 'https://www.creditkarma.com/',
  },
  signUpViewConfig: {
    header:
      "Get auto insurance and peace of mind in minutes. Customize it so you don't have to pay for coverage you don't want.",
    informationalHeader: 'But first...',
    informationalSubHeader: 'Tell us a little about yourself.',
  },
  tenantDisplayName: 'Credit Karma',
  tenantPhoneNumber: '1-855-449-2814',
  vehicleManagementCopyConfig: {
    subheader:
      "We've added the vehicles from your current policy. Feel free to add more or edit our suggestions.",
  },
};

export default config;
